import { render, staticRenderFns } from "./payment-invoice-modal.vue?vue&type=template&id=bbaafa54&"
import script from "./payment-invoice-modal.vue?vue&type=script&lang=js&"
export * from "./payment-invoice-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports